import React, { useEffect, useState } from 'react'
import { createUrl } from '../../Routing/urls'
import { CardSwiper } from '../CardSwiper'
import { PersonStatsCard } from './PersonStatsCard'
import { PlayerDataGQL } from '../../Api'
import { sortPlayersByPosition } from '../../Utils/Players/playersHelper'
import { CURRENT_YEAR } from 'Config/League/league.config'

export type PlayerCardsGroupProps = {
  position?: string
  captains?: PlayerDataGQL[]
  allPlayers?: PlayerDataGQL[]
}

export const PlayerCardsGroup: React.FC<
  React.PropsWithChildren<PlayerCardsGroupProps>
> = ({ position, captains, allPlayers }) => {
  const [playerList, setPlayerList] = useState<PlayerDataGQL[]>([])
  
  useEffect(() => {
    if (captains) {
      setPlayerList(captains)
      return
    }
    if (position) {
      if (!allPlayers || allPlayers.length < 1) return
      const sorted = sortPlayersByPosition(allPlayers, 'lastName', 1).filter(
        (p) => p.position && p.position.toUpperCase() === position.toUpperCase()
      )
      setPlayerList(sorted)
    }
  }, [])

  return (
    <>
      {playerList.length > 0 && (
        <CardSwiper
          items={playerList.map((player) => (
            <PersonStatsCard
              player={player}
              playerPageUrl={createUrl('player', {
                firstName: player.firstName,
                lastName: player.lastName,
                slugName: player.slug,
                tab: 'profile',
              })}
            />
          ))}
          cardSize="playerCard"
        />
      )}
    </>
  )
}
